import {GuiMessage} from './gui-message';

export class WarenkorbActionInfo {
  action: string;
  info: GuiMessage;
}
